// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1hz5L","legacyBtn":"MutateMid_legacyBtn__3kQU_"};